import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../config";
import AuthFormContainer from "../../components/AuthFormContainer/AuthFormContainer";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";

const Forget = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const forgetPassword = () => {
    setLoading(true);
    axios
      .post(`${API}/forgot-password`, {
        email: email,
      })
      .then((response) => {
        setLoading(false);
        swal(
          "Link sent!",
          "We have sent you an reset link in you email!",
          "success",
          {
            button: "Okay",
          }
        );
      })
      .catch((err) => {
        setLoading(false);
        swal("Error!", `${err.response.data.message}`, "error", {
          button: "Okay",
        });
      });
  };
  return (
    <AuthFormContainer
      form={
        <>
          <Input
            type={"email"}
            p={"Please enter your email"}
            setFn={setEmail}
          />
          <Button
            text={"Send Mail"}
            clickFn={forgetPassword}
            loader={loading}
          />
        </>
      }
    />
  );
};

export default Forget;
